import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { environment } from '@environments';
import {
  cachingInterceptorProviders,
  CORE_MESSAGES_SERVICE,
  ENVIRONMENTS,
  ErrorService,
  GlobalErrorHandlerService,
} from '@shared/core';
import { LocalizationModule } from '@shared/modules/localization';
import { kk_KZ, NZ_I18N, ru_RU } from 'ng-zorro-antd/i18n';
import { appRoutes } from './app.routes';
import { authInterceptorProviders } from './core';
import { MessagesModule } from '@shared/modules/messages';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: ENVIRONMENTS,
      useValue: environment,
    },
    { provide: LOCALE_ID, useValue: 'ru' },
    {
      provide: NZ_I18N,
      useFactory: () => {
        const localId = inject(LOCALE_ID);
        switch (localId) {
          case 'ru':
            return ru_RU;
          case 'kk':
          default:
            return kk_KZ;
        }
      },
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    cachingInterceptorProviders,
    authInterceptorProviders,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService,
      deps: [ErrorService, CORE_MESSAGES_SERVICE],
    },
    importProvidersFrom(LocalizationModule.forRoot()),
    importProvidersFrom(MessagesModule.forRoot()),
    provideRouter(appRoutes),
  ],
};
